export default  {
    bindings: {
        property: '<',
        formTab: '=',
        type: '@'
    },
    controller: 'propertyDetailsController',
    template: require('../views/property.business.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/components/property.business.component.js